import { useContext, useEffect, useState } from 'react';
import { getCustomisationValue, updateCustomisationValue } from '../../../EditablePreview/EditablePreview';
import ModuleNumericalInput from '../../components/ModuleNumericalInput';
// import './CustomModule.scss';
import { changeNumericalFieldValue, changeStringFieldValue } from '../../ModuleList';
import ModuleTextInput from '../../components/ModuleTextInput';
import { ShowColorPicker } from '../../../../../../forms/ColorPicker/ColorPickerPopUp';
import { CampaignContext } from "../../../../../../../contexts/CampaignContext";

import ImageIcon from '../../../../WorkspaceAssets/ListIcons/image-icon.png';
import { COLOUR_NAME_TO_COLOUR_HEX } from '../../../../../../../helpers/Colours';

import './ImageField.scss';

const ImageField = (props) => {
    const fieldData = props.fieldData;
    const moduleConfig = props.moduleConfig;
    const groupConfig = props.groupConfig;
    const customisationVars = props.customisationVars;

    const [campaignContext, setCampaignContext] = useContext(CampaignContext);

    const [imageFileData, setImageFileData] = useState(getCustomisationValue(customisationVars, fieldData?.customFieldConfig?.dataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode) ?? null);
    useEffect(() => {
        setImageFileData(getCustomisationValue(customisationVars, fieldData?.customFieldConfig?.dataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode) ?? null);
    }, [customisationVars, fieldData, props.index, props.visualisationComponentKey, props.selectedFeatureNode]);

    const clickHandler = () => {
        props.openTemporaryImageUploadPopup(
            imageFileData,
            (groupConfig?.parent?.name ? groupConfig?.parent?.name + ' > ' : '') + (groupConfig?.name ? groupConfig?.name + ' > ' : '') + moduleConfig.name,
            'This is a temporary image uploader and is not final.',
        )
    }

    const [imageDimensions, setImageDimensions] = useState({width: 'unknown', height: 'unknown'});
    useEffect(() => {
        setImageDimensions({width: 'unknown', height: 'unknown'});
        if (imageFileData?.srcUrl) {
            const img = new Image();
            img.onload = () => {
                setImageDimensions({width: img.width, height: img.height});
            }
            img.src = imageFileData.srcUrl;
        }
    }, [imageFileData, imageFileData?.srcUrl]);

    return (
        <>
            <div className='v2-module-field-label'>{fieldData?.customFieldConfig?.customFieldLabel ?? 'Image'}</div>
            <ModuleTextInput
                fieldLabel={<div className="v2-module-block-field-input-label" style={{backgroundColor: '#FFFFFF', backgroundImage: `url(${ImageIcon})`, backgroundSize: '1.8rem', backgroundRepeat: 'no-repeat', backgroundPosition: 'center'}} />}
                value={typeof imageFileData === 'string' ? imageFileData : imageFileData?.originalFile ?? '<No Image>'}
                fieldId={'image-file'}
                enabled={props.isEnabled}
                editable={false}
                onChange={null}
                onClick={
                    props.isEnabled ? clickHandler : null
                }
            />
            {imageFileData?.srcUrl &&
                <div className={`image-preview-holder${!props.isEnabled ? ' v2-module-disabled-field' : ''}`} onClick={props.isEnabled ? clickHandler : null}>
                    <img src={imageFileData?.srcUrl} alt={imageFileData?.originalFile} />
                    {imageDimensions.width !== 'unknown' &&
                        <div className="image-dimensions-label">{imageDimensions.width} x {imageDimensions.height}</div>
                    }
                    {imageDimensions.width === 'unknown' &&
                        <div className="image-dimensions-label">&nbsp;</div>
                    }
                </div>
            }
        </>
    );
};

export default ImageField;
